import { Loader2 } from 'lucide-react';
import { useT } from '@/lib/i18n/useT';
import type { ImportProgress } from './runImport';

export function ImportProgressView({ progress }: { progress: ImportProgress }) {
  const t = useT();

  const imagesPct =
    progress.imagesTotal > 0 ? (progress.imagesDone / progress.imagesTotal) * 100 : 100;
  const rowsPct =
    progress.rowsTotal > 0 ? (progress.rowsDone / progress.rowsTotal) * 100 : 0;

  const imagesActive = progress.phase === 'uploadingImages';
  const rowsActive = progress.phase === 'writingStock';

  return (
    <div className="space-y-5 p-2">
      <PhaseRow
        label={t('stock.import.progress.upload')}
        done={progress.imagesDone}
        total={progress.imagesTotal}
        pct={imagesPct}
        active={imagesActive}
        complete={!imagesActive && progress.imagesTotal > 0}
      />
      <PhaseRow
        label={t('stock.import.progress.create')}
        done={progress.rowsDone}
        total={progress.rowsTotal}
        pct={rowsPct}
        active={rowsActive}
        complete={progress.phase === 'done'}
      />
    </div>
  );
}

function PhaseRow({
  label,
  done,
  total,
  pct,
  active,
  complete,
}: {
  label: string;
  done: number;
  total: number;
  pct: number;
  active: boolean;
  complete: boolean;
}) {
  return (
    <div>
      <div className="mb-1.5 flex items-center justify-between text-[12px]">
        <div className="flex items-center gap-2 font-bold text-[var(--color-xk-lavender)]">
          {active && <Loader2 className="h-3.5 w-3.5 animate-spin text-[var(--color-accent-ink)]" />}
          {label}
        </div>
        <div className="text-[11px] text-[var(--color-xk-text-muted)]">
          {done} / {total}
        </div>
      </div>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-[var(--color-xk-surface)]">
        <div
          className="h-full bg-[var(--color-xk-accent)] transition-all"
          style={{
            width: `${complete ? 100 : Math.min(100, Math.max(0, pct))}%`,
            opacity: active || complete ? 1 : 0.4,
          }}
        />
      </div>
    </div>
  );
}
